export default "__VITE_ASSET__CRh5xCTE__"